<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1526_21614)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11 14H6C3.79086 14 2 15.7909 2 18V20H15V18C15 15.7909 13.2091 14 11 14ZM6 12C2.68629 12 0 14.6863 0 18V21C0 21.5523 0.447715 22 1 22H16C16.5523 22 17 21.5523 17 21V18C17 14.6863 14.3137 12 11 12H6Z"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0001 21.5C19.0001 21.7761 19.2239 22 19.5001 22L23.0001 22C23.5524 22 24.0001 21.5523 24.0001 21V18C24.0001 14.6863 21.3138 12 18.0001 12H17.9729C17.4779 12 17.2313 12.7174 17.5538 13.093C17.7374 13.3068 17.9062 13.5337 18.0587 13.7721C18.1502 13.9152 18.3033 14.0077 18.472 14.0275C20.4587 14.261 22.0001 15.9505 22.0001 18V19.5C22.0001 19.7761 21.7762 20 21.5001 20H19.5001C19.2239 20 19.0001 20.2239 19.0001 20.5V21.5Z" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 9C9.88071 9 11 7.88071 11 6.5C11 5.11929 9.88071 4 8.5 4C7.11929 4 6 5.11929 6 6.5C6 7.88071 7.11929 9 8.5 9ZM8.5 11C10.9853 11 13 8.98528 13 6.5C13 4.01472 10.9853 2 8.5 2C6.01472 2 4 4.01472 4 6.5C4 8.98528 6.01472 11 8.5 11Z"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.06 8.96139C14.7853 8.9126 14.493 9.03674 14.3731 9.2887C14.2466 9.55463 14.1026 9.8106 13.9426 10.0551C13.7658 10.3252 13.8514 10.7009 14.1596 10.797C14.583 10.9289 15.0332 11 15.5001 11C17.9854 11 20.0001 8.98528 20.0001 6.5C20.0001 4.01472 17.9854 2 15.5001 2C15.0332 2 14.583 2.07109 14.1596 2.20303C13.8514 2.29907 13.7658 2.67477 13.9426 2.94487C14.1026 3.1894 14.2466 3.44537 14.3731 3.71129C14.493 3.96325 14.7853 4.0874 15.06 4.03861C15.2028 4.01324 15.3499 4 15.5001 4C16.8808 4 18.0001 5.11929 18.0001 6.5C18.0001 7.88071 16.8808 9 15.5001 9C15.3499 9 15.2028 8.98676 15.06 8.96139Z" />
    </g>
    <defs>
      <clipPath id="clip0_1526_21614">
        <rect width="24" height="24" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
}
</script>
